export default __webpack_public_path__ + "static/media/testimony_teacher_six.0e42640a.png";